import { Button, Grid } from '@material-ui/core';
import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { connect } from 'react-redux';
import addInfoToAgreement from '../../../../api/Purchasers/addInfoToAgreement.api';
import { getFormItems } from '../../../../redux/forms/actions';
import { closeModal, openModal } from '../../../../redux/modals/action';
import { removeClient } from '../../../../redux/agreement/actions';
import { validateEmail } from '../../../../utils/validateEmail';
import styles from './PurchaserForm.module.scss';
import _, { set } from 'lodash';
import {
	checkForValueInJson,
	checkEmptyRequiredFields,
} from '../../../../utils/checkForValueInJson';
import { setAlert } from '../../../../redux/alerts/action';
import {
	validatePhoneNumber,
	reformatPhoneString,
} from '../../../../utils/validatePhoneNumber';
import AddressAutocomplete from '../../../addressAutocomplete/AddressAutocomplete';
import {
	saveClientInfoData,
	createSecondaryClient,
	saveClientNamePurchaser,
} from '../../../../api/Agreement/handleClientInfo.api';
import Modal from '../../../layout/modal/Modal';
import CustomTextField from '../../../layout/customTextField/CustomTextField';
// import { closeModal, openModal } from '../../../../redux/modals/action';

const PurchaserForm = ({
	// parent props
	showModal,
	leadId,
	isEditClientForms,
	purchaserForm,
	closePurchaserForm,
	// redux
	setAlert,
	individualData,
	formFields,
	getFormItems,
	openModal,
	removeClient,
}) => {
	const addressInputs = formFields?.address;
	const inputs = purchaserForm?.hasOwnProperty('corporationName')
		? formFields?.corporation
		: formFields?.individual;

	const [formData, setFormData] = useState({});
	const [error, setError] = useState();

	useEffect(() => {
		getFormItems('agreement', 'clientInfo');
	}, []);

	useEffect(() => {
		setError();
		if (purchaserForm) {
			setFormData(purchaserForm);
		} else {
			clearDefaultData();
		}
	}, [formFields, leadId, purchaserForm, isEditClientForms]);

	const clearDefaultData = () => {
		if (inputs && addressInputs) {
			let formObj = inputs?.formData;
			delete formObj.dateOfBirth;
			let combinedForm = Object.assign(formObj, addressInputs.formData);
			setFormData(combinedForm);
		}
		setError();
	};
	const onChange = (e) => {
		let value = e.target.value;
		if (e.target.value === '' && e.target.name !== 'address2') {
			setError({ ...error, [e.target.name]: true });
		} else {
			error && delete error[e.target.name];
		}

		if (e.target.name === 'email') {
			if (
				validateEmail(e.target.value) !== true ||
				e.target.value === ''
			) {
				setError({ ...error, [e.target.name]: true });
			} else {
				error && delete error[e.target.name];
			}
		}
		if (e.target.name === 'phoneNumber') {
			if (
				validatePhoneNumber(e.target.value) !== true ||
				e.target.value === ''
			) {
				setError({ ...error, [e.target.name]: true });
			} else {
				value = reformatPhoneString(e.target.value);
				error && delete error[e.target.name];
			}
		}
		setFormData({ ...formData, [e.target.name]: value });
	};

	const handleAddDoc = (e) => {
		e.preventDefault();
		let isNameChanged =
			formData?.firstName?.toLowerCase() ===
				purchaserForm?.firstName?.toLowerCase() &&
			formData?.lastName?.toLowerCase() ===
				purchaserForm?.lastName?.toLowerCase()
				? false
				: true;
		// 1-1. Empty check
		let chkFields = checkEmptyRequiredFields(formData, inputs?.fields);
		let checkAddressFields = checkEmptyRequiredFields(
			formData,
			addressInputs?.fields
		);

		// 1-2. Form Validation check
		let combinedErr = Object.assign(chkFields, checkAddressFields, error);
		setError(combinedErr);

		if (
			_.isEmpty(combinedErr) === true &&
			_.isEmpty(error) === true &&
			checkForValueInJson(error, true) !== true
		) {
			// 2. Validate -> Update or Add Purchaser
			if (purchaserForm?.hasOwnProperty('corporationName')) {
				// to save corporatio user after edit
				saveClientInfoData(leadId, 'corporation', formData);
			} else if (!isEditClientForms) {
				// to add new purchaser
				createSecondaryClient(leadId, formData, (newObj) => {
					if (newObj) console.log('Succses message');
				});
			} else if (isEditClientForms) {
				// to save individual user after edit
				saveClientInfoData(
					leadId,
					'individual',
					formData,
					isNameChanged
				);
			}
			// 3. (If primary user name is changed?)  Update purchaser table name too
			if (isNameChanged && isEditClientForms) {
				if (purchaserForm?.isPrimary === true) {
					saveClientNamePurchaser(leadId, formData);
				}
			}
			openModal('clientDetails');
		}
	};
	const onClickDeletePurchaserList = () => {
		console.log('purchaserForm', purchaserForm);
		let individualId = purchaserForm?.id;
		let ObjKeys = individualData && Object.keys(individualData);
		if (ObjKeys.length === 1) {
			setAlert(
				'error',
				'You can not delete when there is only one user.'
			);
		} else {
			leadId && individualId && removeClient(leadId, individualId);
		}
		openModal('clientDetails');
	};

	return (
		<Modal
			title={isEditClientForms ? 'Edit Purchaser' : 'Add Purchaser'}
			show={showModal}
			close={() => closePurchaserForm(leadId)}
			wrapperWidth='90%'
			wrapperMax={830}
		>
			<form
				onSubmit={handleAddDoc}
				method='POST'
				className={styles.clientInfoFormWrapper}
				noValidate
			>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}>
						{inputs?.fields &&
							inputs?.fields?.map((field, index) => {
								if (field?.formName !== 'dateOfBirth') {
									return (
										<div key={index}>
											<CustomTextField
												formLabel={field?.formLabel}
												name={field?.formName}
												value={
													formData[field?.formName] ??
													''
												}
												onChange={(e) => onChange(e)}
												type={field?.formType}
												InputLabelProps={{
													shrink: true,
												}}
												required={
													field?.required === true
														? true
														: false
												}
												error={
													error &&
													error[field?.formName] ===
														true
														? true
														: false
												}
												errorMessage={
													field?.errorMessage
												}
												placeholder={field?.formLabel}
												autoComplete='off'
											/>
										</div>
									);
								}
							})}
					</Grid>
					<Grid item xs={12} sm={6}>
						<AddressAutocomplete
							formData={formData}
							setFormData={setFormData}
							onChange={(e) => onChange(e)}
							error={error}
							setError={setError}
							defaultData={purchaserForm?.address1}
						/>
					</Grid>
				</Grid>
				<div className={styles.deleteBtnWrapper}>
					{isEditClientForms && purchaserForm?.isPrimary === false ? (
						<Button
							className={styles.delete_btn}
							onClick={onClickDeletePurchaserList}
							startIcon={<DeleteIcon />}
						>
							Delete Purchaser
						</Button>
					) : (
						<span></span>
					)}
					{/* {isEditClientForms &&
					!purchaserForm?.hasOwnProperty('corporationName') ? (
						<Button
							className={styles.delete_btn}
							onClick={onClickDeletePurchaserList}
							startIcon={<DeleteIcon />}
						>
							Delete Purchaser
						</Button>
					) : (
						<span></span>
					)} */}
					<div className={styles.confirmBtnWrapper}>
						<Button
							className={styles.cancelBtn}
							onClick={() => closePurchaserForm(leadId)}
						>
							Cancel
						</Button>
						<Button type='submit' className={styles.addBtn}>
							{isEditClientForms ? 'Save Changes' : 'Confirm'}
						</Button>
					</div>
				</div>
			</form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	formFields: state.forms.form?.clientInfo,
	individualData: state.agreement?.agreementById?.clientInfo?.individual,
});

export default connect(mapStateToProps, {
	getFormItems,
	closeModal,
	openModal,
	setAlert,
	removeClient,
})(PurchaserForm);
